import grid1Asset from "@/assets/grid1.webm.asset.json";

export const GRID1_VIDEO_URL = grid1Asset.url;
